import { Link } from "react-router-dom";

// PIPA notice + CASL express-consent checkbox (unchecked by default, separate from submission)
export default function ConsentField({ checked, onChange, testId = "consent-marketing", dark = true }) {
  const text = dark ? "text-[#D8D6D0]/60" : "text-[#151515]/60";
  const fine = dark ? "text-[#D8D6D0]/40" : "text-[#151515]/45";
  return (
    <div className="space-y-3">
      <label className={`flex items-start gap-3 text-xs ${text} cursor-pointer select-none`}>
        <input
          type="checkbox"
          data-testid={testId}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          className="mt-0.5 w-4 h-4 accent-[#8C1D30] flex-shrink-0"
        />
        <span>
          I'd like to receive occasional landscaping tips and offers from NorthCrest Landscaping.
          You can unsubscribe anytime.
        </span>
      </label>
      <p className={`text-[11px] leading-relaxed ${fine}`}>
        By submitting, you consent to NorthCrest Landscaping collecting this information to respond
        to your request, as described in our{" "}
        <Link to="/privacy-policy" data-testid={`${testId}-privacy-link`} className="underline underline-offset-2 hover:text-[#8C1D30]">
          Privacy Policy
        </Link>.
      </p>
    </div>
  );
}
